import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { Link } from "gatsby"


class Llamado extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            padding-top: 10px;
            background-color: #fff;            
        `

        const AboutContainer = styled(Container)`
            padding: 50px 0;
            @media (max-width: 500px) {
                padding: 50px 20px;
            }
        `

        const Heading4 = styled.h4`
            font-size: 30px;
            font-family: Poppins;
            color: #48565e;
            line-height: 80px;
            text-align: center;
            padding-bottom: 20px;        
        `
        const Heading3 = styled.h3`
            font-size: 30px;
            font-family: Poppins;
            color: #48565e;
            line-height: 80px;
            text-align: center;
            padding-bottom: 20px;        
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #48565e;
            padding-bottom: 30px;
        `

        const TextaSpan = styled(Link)`        
        color: #78c91c;
        transition: .5s;
          &:hover {
            color: #000;
            text-decoration: none;
          }
        `

        const Texta = styled.a`        
        color: #78c91c;
        transition: .5s;
          &:hover {
            color: #000;
            text-decoration: none;
          }
        `
        const TextaSpana = styled.a`        
            color: #78c91c;
            transition: .5s;
            scroll-behavior: smooth;
            &:hover {
                color: #fff;
                text-decoration: none;
            }
        `
        const handleScrollToCA = (e) => {
            e.preventDefault();
            const target = document.getElementById('QA');
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };


        return (
            <Section>
                <AboutContainer>
                    <Row>
                        <Col md={12}>
                            <Heading3>
                                <TextaSpan to="/conecta">Cotiza tu Certificado SSL sin ONAC</TextaSpan>
                            </Heading3>
                            <Heading4>
                                Si tienes más preguntas o deseas obtener información adicional sobre
                                los Certificados SSL, ¡estamos aquí para ayudarte!
                            </Heading4>
                            <Text>
                                Para respuestas rápidas a <TextaSpana a href="#QA" onClick={handleScrollToCA}>preguntas frecuentes</TextaSpana>, te invitamos a visitar nuestra sección en esta página.
                            </Text>
                            <Text>
                                Si prefieres una información más detallada o extensa, te recomendamos explorar nuestra <Texta href="https://vascosolutions.com/zc/index.php/knowledgebase/1/Certificados-Digitales-SSL" target='_blank'>Zona de Clientes</Texta> o contactarnos directamente.
                            </Text>
                        </Col>
                    </Row>
                </AboutContainer>
            </Section>

        )
    }
}

export default Llamado